<template>
  <div>
    <vs-breadcrumb v-if="userAccount === 'betagrodemo'">
      <li>
        <a aria-current="page" style="color: #ffffff" title="Setting">Setting</a
        ><span style="color: #ffffff" class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link
          style="color: #ffffff"
          :to="'IndoorAlertSetting'"
          title="Alert Setting"
          >Alert Setting</router-link
        ><span style="color: #ffffff" class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Edit Alert</li>
    </vs-breadcrumb>
    <vs-breadcrumb v-else>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Setting"
          >Setting</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'IndoorAlertSetting'" title="Alert Setting"
          >Alert Setting</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Edit Alert</li>
    </vs-breadcrumb>

    <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px;">
    <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item to="/action"><h5>Alert Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Edit Alert</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
    <vs-row>
      <vs-card style="border-radius: 20px">
        <h4 class="mt-2">Create / Edit Alert</h4>

        <span>
          <vs-input
            style="min-width: 400px; color: #111111"
            icon-no-border
            icon="notifications"
            label-placeholder="Alert Name"
            v-model="name"
        /></span>
        <vs-row class="mt-4" vs-align="center">
          <span class="mr-4">Single / Multiple</span>
          <vs-switch v-model="switchAlert">
            <span slot="on">Multiple</span>
            <span slot="off">Single</span>
          </vs-switch>
        </vs-row>
      </vs-card>
    </vs-row>
    <vs-row>
      <vs-card style="border-radius: 20px">
        <h4 class="mt-2">IF (Condition​)</h4>
        <br />

        <vs-table :data="conditionlist" v-if="userAccount === 'betagrodemo'">
          <template slot="thead">
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >ID
            </vs-th>
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >Sensor Type
            </vs-th>
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >Sensor Name
            </vs-th>
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >Option
            </vs-th>
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >Value
            </vs-th>
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
            >
              Delete
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :key="indextr"
              v-for="(tr, indextr) in data"
              class="border"
              style="background: #212121; color: #ffffff"
            >
              <vs-td :data="data[indextr].id" class="border">
                {{ data[indextr].id }}
              </vs-td>
              <vs-td class="border">
                <vs-select
                  class="selectExample mt-1"
                  autocomplete
                  v-model="conditionlist[indextr].type"
                  style="color: #111111"
                  @change="actionchange(conditionlist[indextr].type, indextr)"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in sensorread"
                  />
                </vs-select>
              </vs-td>
              <vs-td class="border">
                <vs-select
                  class="selectExample mt-1"
                  style="color: #111111"
                  autocomplete
                  v-model="conditionlist[indextr].sensid"
                  @change="sensorchange(conditionlist[indextr].sensid, indextr)"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item, index) in filtersensor[indextr]"
                  />
                </vs-select>
              </vs-td>
              <vs-td class="border">
                <vs-select
                  style="color: #111111"
                  v-if="
                    conditionlist[indextr].type == 'advantech' ||
                    conditionlist[indextr].type == 'ssc'
                  "
                  class="selectExample mt-1"
                  autocomplete
                  v-model="conditionlist[indextr].advancon"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.name"
                    v-for="(item, index) in address[indextr]"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  class="selectExample mt-1"
                  v-else-if="conditionlist[indextr].type == 'Sensor'"
                  autocomplete
                  v-model="conditionlist[indextr].loracon"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in lorakey[indextr]"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  class="selectExample mt-1"
                  v-else-if="
                    conditionlist[indextr].type == 'lora' ||
                    conditionlist[indextr].type == 'mqtt' ||
                    conditionlist[indextr].type == 'aqi' ||
                    conditionlist[indextr].type == 'cpf' ||
                    conditionlist[indextr].type == 'hino' ||
                    conditionlist[indextr].type == 'qcon' ||
                    conditionlist[indextr].type == 'ajino' ||
                    conditionlist[indextr].type == 'frasers' ||
                    conditionlist[indextr].type == 'monnit'
                  "
                  autocomplete
                  v-model="conditionlist[indextr].loracon"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in lorakey[indextr]"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  class="selectExample mt-1"
                  v-else-if="conditionlist[indextr].type == 'lkb'"
                  autocomplete
                  v-model="conditionlist[indextr].loracon"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in lorakey[indextr]"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  class="selectExample mt-1"
                  autocomplete
                  v-model="conditionlist[indextr].con"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in senconequ[indextr]"
                  />
                </vs-select>

                <!-- <vs-row  vs-w="12">
                <div v-if="conditionlist[indextr].type == 'advantech'">
                <vs-col class="mr-1 mt-1" style="padding: 0px;" vs-xs="12">
                  <vs-select
                   
                    autocomplete
                    v-model="conditionlist[indextr].advancon"
                    >
                    <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item,index) in address[indextr]" />
                  </vs-select>
                </vs-col>
                </div>
                
                <vs-col class="mr-1 mt-1" vs-xs="12" v-else-if="conditionlist[indextr].type == 'lora'"  style="padding: 0px;"  >        
                   <vs-select
                   class=" container-fluid"
                    autocomplete
                    v-model="conditionlist[indextr].loracon"
                    >
                    <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in lorakey[indextr]" />
                  </vs-select>
                </vs-col>
              
                <vs-col class=" mt-1"  vs-xs="12" style="padding: 0px;">
                <vs-select
                  autocomplete
                  class="container-fluid"
                  v-model="conditionlist[indextr].con"
                  >
                  <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in sencon[indextr]" />
                </vs-select>
                </vs-col>
              </vs-row> -->
              </vs-td>
              <vs-td class="border">
                <vs-select
                  style="color: #111111"
                  autocomplete
                  class="container-fluid"
                  v-model="conditionlist[indextr].value"
                  v-if="conditionlist[indextr].loracon == 'WaterDetect'"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.name"
                    v-for="(item, index) in TFlist"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  autocomplete
                  class="container-fluid"
                  v-model="conditionlist[indextr].value"
                  v-else-if="
                    conditionlist[indextr].loracon == 'uninstalled' ||
                    conditionlist[indextr].loracon == 'unlocked' ||
                    conditionlist[indextr].loracon == 'triggered'
                  "
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.name"
                    v-for="(item, index) in Indoorlist"
                  />
                </vs-select>
                <vs-input
                  style="color: #111111"
                  v-else
                  v-model="conditionlist[indextr].value"
                ></vs-input>
              </vs-td>
              <vs-td class="border">
                <vs-button
                  class="text-danger mr-2"
                  color="danger"
                  type="flat"
                  icon="delete"
                  @click="pop()"
                  >Delete</vs-button
                >
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-table :data="conditionlist" v-else>
          <template slot="thead">
            <vs-th class="border fontSizeData">ID </vs-th>
            <vs-th class="border fontSizeData">Sensor Type </vs-th>
            <vs-th class="border fontSizeData">Sensor Name </vs-th>
            <vs-th class="border fontSizeData">Option </vs-th>
            <vs-th class="border fontSizeData">Value </vs-th>
            <vs-th class="border fontSizeData">Delete </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="border">
              <vs-td :data="data[indextr].id" class="border">
                {{ data[indextr].id }}
              </vs-td>
              <vs-td class="border">
                <vs-select
                  class="selectExample mt-1"
                  autocomplete
                  v-model="conditionlist[indextr].type"
                  style="color: #111111"
                  @change="actionchange(conditionlist[indextr].type, indextr)"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in sensorread"
                  />
                </vs-select>
              </vs-td>
              <vs-td class="border">
                <vs-select
                  class="selectExample mt-1"
                  style="color: #111111"
                  autocomplete
                  v-model="conditionlist[indextr].sensid"
                  @change="() => sensorchange(conditionlist[indextr].sensid, indextr)"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item, index) in filtersensor[indextr]"
                  />
                </vs-select>
              </vs-td>
              <vs-td class="border">
                <vs-select
                  style="color: #111111"
                  v-if="
                    conditionlist[indextr].type == 'advantech' ||
                    conditionlist[indextr].type == 'ssc'
                  "
                  class="selectExample mt-1"
                  autocomplete
                  v-model="conditionlist[indextr].advancon"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.name"
                    v-for="(item, index) in address[indextr]"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  class="selectExample mt-1"
                  v-else-if="conditionlist[indextr].type == 'Sensor'"
                  autocomplete
                  v-model="conditionlist[indextr].loracon"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in lorakey[indextr]"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  class="selectExample mt-1"
                  v-else-if="
                    conditionlist[indextr].type == 'lora' ||
                    conditionlist[indextr].type == 'aqi' ||
                    conditionlist[indextr].type == 'mqtt' ||
                    conditionlist[indextr].type == 'cpf' ||
                    conditionlist[indextr].type == 'hino' ||
                    conditionlist[indextr].type == 'qcon' ||
                    conditionlist[indextr].type == 'ajino' ||
                    conditionlist[indextr].type == 'frasers' ||
                    conditionlist[indextr].type == 'monnit'
                  "
                  autocomplete
                  v-model="conditionlist[indextr].loracon"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in lorakey[indextr]"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  class="selectExample mt-1"
                  v-else-if="conditionlist[indextr].type == 'lkb'"
                  autocomplete
                  v-model="conditionlist[indextr].loracon"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in lorakey[indextr]"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  class="selectExample mt-1"
                  autocomplete
                  v-model="conditionlist[indextr].con"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in senconequ[indextr]"
                  />
                </vs-select>

                <!-- <vs-row  vs-w="12">
                <div v-if="conditionlist[indextr].type == 'advantech'">
                <vs-col class="mr-1 mt-1" style="padding: 0px;" vs-xs="12">
                  <vs-select
                   
                    autocomplete
                    v-model="conditionlist[indextr].advancon"
                    >
                    <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item,index) in address[indextr]" />
                  </vs-select>
                </vs-col>
                </div>
                
                <vs-col class="mr-1 mt-1" vs-xs="12" v-else-if="conditionlist[indextr].type == 'lora'"  style="padding: 0px;"  >        
                   <vs-select
                   class=" container-fluid"
                    autocomplete
                    v-model="conditionlist[indextr].loracon"
                    >
                    <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in lorakey[indextr]" />
                  </vs-select>
                </vs-col>
              
                <vs-col class=" mt-1"  vs-xs="12" style="padding: 0px;">
                <vs-select
                  autocomplete
                  class="container-fluid"
                  v-model="conditionlist[indextr].con"
                  >
                  <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in sencon[indextr]" />
                </vs-select>
                </vs-col>
              </vs-row> -->
              </vs-td>
              <vs-td class="border">
                <vs-select
                  style="color: #111111"
                  autocomplete
                  class="container-fluid"
                  v-model="conditionlist[indextr].value"
                  v-if="conditionlist[indextr].loracon == 'WaterDetect'"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.name"
                    v-for="(item, index) in TFlist"
                  />
                </vs-select>
                <vs-select
                  style="color: #111111"
                  autocomplete
                  class="container-fluid"
                  v-model="conditionlist[indextr].value"
                  v-else-if="
                    conditionlist[indextr].loracon == 'uninstalled' ||
                    conditionlist[indextr].loracon == 'unlocked' ||
                    conditionlist[indextr].loracon == 'triggered'
                  "
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.name"
                    v-for="(item, index) in Indoorlist"
                  />
                </vs-select>
                <vs-input
                  style="color: #111111"
                  v-else
                  v-model="conditionlist[indextr].value"
                ></vs-input>
              </vs-td>
              <vs-td class="border">
                <vs-button
                  class="text-danger mr-2"
                  color="danger"
                  type="flat"
                  icon="delete"
                  @click="pop()"
                  >Delete</vs-button
                >
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <br />
        <vs-button
          v-if="userAccount !== 'dhanarak-admin'"
          color="#007bff"
          class="mb-4"
          type="flat"
          icon="add"
          @click="addnewsens"
          >Add New Sensor</vs-button
        >
        <!-- <vs-button type="filled" @click="addnewsens">Add New Sensor</vs-button> -->
      </vs-card>
    </vs-row>
    <vs-row>
      <vs-card style="border-radius: 20px">
        <h4 class="mt-2">THEN (Action)</h4>
        <br />
        <vs-table :data="actionlist" v-if="userAccount === 'betagrodemo'">
          <template slot="thead">
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >ID
            </vs-th>
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >Type
            </vs-th>
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >Detail
            </vs-th>
            <vs-th
              class="border fontSizeData"
              style="background: #484848; color: #ffffff"
              >Delete
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :key="indextr"
              v-for="(tr, indextr) in data"
              class="border"
              style="background: #212121; color: #ffffff"
            >
              <vs-td :data="data[indextr].id" class="border">
                {{ data[indextr].id }}
              </vs-td>
              <vs-td :data="data[indextr].name" class="border">
                <vs-select
                  style="color: #111111"
                  class="selectExample"
                  autocomplete
                  v-model="actionlist[indextr].name"
                  @change="alertchange(actionlist[indextr].namee, indextr)"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in actiontype"
                  />
                </vs-select>
              </vs-td>
              <vs-td :data="data[indextr].detail" class="border">
                <vs-select
                  style="color: #111111"
                  v-if="actionlist[indextr].name == 'User E-mail'"
                  class="selectExample"
                  autocomplete
                  v-model="actionlist[indextr].detail"
                  @change="detailchange(actionlist[indextr].detail, indextr)"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.email"
                    :text="item.email"
                    v-for="(item, index) in emaillist"
                  />
                </vs-select>
                <vs-input
                  style="color: #111111"
                  v-else-if="actionlist[indextr].name == 'Other E-mail'"
                  v-model="actionlist[indextr].detail"
                >
                </vs-input>
              </vs-td>
              <vs-td class="border">
                <vs-button
                  class="text-danger mr-2"
                  color="danger"
                  type="flat"
                  icon="delete"
                  @click="actpop()"
                  >Delete</vs-button
                >
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-table :data="actionlist" v-else>
          <template slot="thead">
            <vs-th class="border fontSizeData">ID </vs-th>
            <vs-th class="border fontSizeData">Type </vs-th>
            <vs-th class="border fontSizeData">Detail </vs-th>
            <vs-th class="border fontSizeData">Delete </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="border">
              <vs-td :data="data[indextr].id" class="border">
                {{ data[indextr].id }}
              </vs-td>
              <vs-td :data="data[indextr].name" class="border">
                <vs-select
                  style="color: #111111"
                  class="selectExample"
                  autocomplete
                  v-model="actionlist[indextr].name"
                  @change="alertchange(actionlist[indextr].namee, indextr)"
                >
                  <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item, index) in actiontype"
                  />
                </vs-select>
              </vs-td>
              <vs-td :data="data[indextr].detail" class="border">
                <vs-select
                  style="color: #111111"
                  v-if="actionlist[indextr].name == 'User E-mail'"
                  class="selectExample"
                  autocomplete
                  v-model="actionlist[indextr].detail"
                  @change="detailchange(actionlist[indextr].detail, indextr)"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.email"
                    :text="item.email"
                    v-for="(item, index) in emaillist"
                  />
                </vs-select>
                <vs-input
                  style="color: #111111"
                  v-else-if="actionlist[indextr].name == 'Other E-mail'"
                  v-model="actionlist[indextr].detail"
                >
                </vs-input>
              </vs-td>
              <vs-td class="border">
                <vs-button
                  class="text-danger mr-2"
                  color="danger"
                  type="flat"
                  icon="delete"
                  @click="actpop()"
                  >Delete</vs-button
                >
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <br />
        <vs-button
          color="#007bff"
          class="mb-4"
          type="flat"
          icon="add"
          @click="addnewact"
          >Add New Action</vs-button
        >
        <!-- <vs-button type="filled" @click="addnewact">Add New Action</vs-button> -->
        <vs-row class="mt-3 mb-3" vs-w="12">
          <vs-col class="mt-2" vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-button
              style="border-radius: 18px"
              color="success"
              type="filled"
              @click="send"
              v-if="mode == 'create'"
              >Create Action</vs-button
            >
            <vs-button
              style="border-radius: 18px"
              color="success"
              type="filled"
              @click="send"
              v-if="mode == 'edit'"
              >Save Edit</vs-button
            >
            <vs-button class="ml-2" color="dark" to="/action" type="flat"
              >Cancel</vs-button
            >
          </vs-col>
        </vs-row>
      </vs-card>
      <!-- <vs-button type="filled" @click="send" v-if="mode == 'create'">Create Action</vs-button>
    <vs-button type="filled" @click="send" v-if="mode == 'edit'">Save Edit</vs-button> -->
    </vs-row>
    <!-- <vs-row>
  <vs-card>
    <h4 class="card-title d-flex">
      Select Binding Sensors
    </h4>
    <vs-row>
      <vs-col vs-lg="3" vs-xs="6" v-for="item in this.sensorlist" :key="item.id" >
        <vs-checkbox v-model="checkarray" :vs-value="item.serial_id" color="#333f50" style="justify-content: start;">{{item.name}}</vs-checkbox>
      </vs-col>
    </vs-row>
  </vs-card>
</vs-row>
<vs-row>
  <vs-col vs-lg="6" vs-xs="12">
      <vs-card>
        <vs-dropdown>
          <a class="a-icon" href.prevent>
            {{this.actionselect}}
            <vs-icon class icon="expand_more"></vs-icon>
          </a>
          <vs-dropdown-menu>
            <vs-dropdown-group vs-collapse vs-label="Sensor Reading" vs-icon="add">
              <vs-dropdown-item v-for="list in sensorread" :key="list" @click="actionchange(1,list)">{{list}}</vs-dropdown-item>
            </vs-dropdown-group>
            <vs-dropdown-item v-for="item in maingroup" :key="item.group" @click="actionchange(1,item.group)">
            {{item.group}}</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </vs-card>
  </vs-col>
  <vs-col vs-lg="6" vs-xs="12">
  <vs-card v-if="this.actionselect === 'Temperature'">
    <div class="default-input d-flex align-items-center">
      <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{this.con}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in sencon" :key="item" @click="actionchange(2,item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-input color="#333f50" 
        label="Value"
        class="inputx ml-3"
        type="number"
        placeholder="0"
        v-model="value"
      />
    </div>
  </vs-card>
  <vs-card v-if="this.actionselect === 'Humidity'">
    <div class="default-input d-flex align-items-center">
      <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{this.con}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in sencon" :key="item" @click="actionchange(2,item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-input color="#333f50" 
        label="Value"
        class="inputx ml-3"
        type="number"
        placeholder="%"
        v-model="value"
      />
    </div>
  </vs-card>
  <vs-card v-if="this.actionselect === 'Powermeter'">
    <div class="default-input d-flex align-items-center">
      <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{this.pt}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in powertype" :key="item" @click="actionchange(3,item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-dropdown>
      <a class="a-icon" href.prevent>
        {{this.con}}
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="item in sencon" :key="item" @click="actionchange(2,item)">
        {{item}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-input color="#333f50" 
        label="Value"
        class="inputx ml-3"
        type="number"
        placeholder="0"
        v-model="value"
      />
    </div>
  </vs-card>
  </vs-col>
</vs-row>
<vs-row>
  <vs-col v-if="this.actionselect !== 'Action Select'">
    <vs-row>
      <vs-card>
        <vs-select
          placeholder="Select"
          multiple
          autocomplete
          class="selectExample"
          label="Notification"
          v-model="then"
          @change="change()"
          >
          <vs-select-item :key="index" :value="item.text" :text="item.text" v-for="(item,index) in options2" />
        </vs-select>
      </vs-card>
    </vs-row>
    <vs-row v-if="this.then[0] === 'E-Mail' || this.then[1] === 'E-Mail'">
      <vs-card>
        <p>E-Mail Box</p>
        <vs-col vs-lg="6" vs-xs="12">
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12">
          <vs-table stripe 
      multiple
      v-model="selected"
      :data="users"> 
      <template slot="thead">
        <vs-th>
          Email
        </vs-th>
        <vs-th>
          Name
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td>
            {{data[indextr].email}}
          </vs-td>
          <vs-td>
            {{data[indextr].name}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
        </vs-col>
      </vs-card>
    </vs-row>
    <vs-row v-if="this.then[0] === 'LINE Notification' || this.then[1] === 'LINE Notification'">
      <vs-card>
        <p>LINE Box</p>
      </vs-card>
    </vs-row>
  </vs-col>
</vs-row>
  <vs-row>
    <vs-button type="filled" size="large" v-if="this.actionselect !== 'Action Select'" color="#333f50" @click="send()">Confirm</vs-button>
  </vs-row> -->
  </div>
</template>

<script>
export default {
  name: "CreateAction",
  data: () => ({
    id: "",
    switchAlert: false,
    assignee: "",
    controlstatus: [
      { name: "ON -> OFF", value: false },
      { name: "OFF -> ON", value: true },
    ],
    status: [
      { name: "Connect", value: false },
      { name: "Disconnect", value: true },
    ],
    testmode: "Unavailable",
    sensname: [],
    actionselect: [],
    actiontype: ["User E-mail", "Other E-mail", "LINE", "Control"],
    actionlist: [{ id: 1, name: "", detail: "" }],
    name: "",
    input: [],
    checkarray: [],
    typeselect: "Type Select",
    maingroup: [{ group: "Battery Level" }, { group: "Device Inactivity" }],
    sensorread: [],
    indoorCheck: false,
    // powertype: ["VoltageL1","VoltageL2","VoltageL3","TotalPhaseVoltage","CurrentL1","CurrentL2","CurrentL3","TotalCurrent",
    //             "VoltageL1L2","VoltageL2L3","VoltageL3L1","TotalPtoPVoltage","ActivePowerL1","ActivePowerL2","ActivePowerL3","TotalActivePower",
    //             "ReactivePowerL1","ReactivePowerL2","ReactivePowerL3","TotalReactivePower","ApparentPowerL1","ApparentPowerL2","ApparentPowerL3","TotalApparentPower",
    //             "PowerFactorL1","PowerFactorL2","PowerFactorL3","TotalPowerFactor","Frequency","TotalimpActiveEnergy","TotalexportedActiveEnergy",
    //             "TotalimpReactiveEnergy","TotalexpReactiveEnergy","TotalApparentEnergy"],
    sencon: [["Greater Than", "Less Than"]],
    senconequ: [["Greater Than", "Less Than", "Equal To"]],
    address: [[]],
    thenlist: ["E-mail", ""],
    pt: "Type",
    unit: ["Celcius", "Fahrenheit"],
    value: "",
    options2: [
      { text: "E-Mail", value: 1 },
      { text: "LINE Notification", value: 2 },
    ],
    then: "",
    users: [
      { email: "napat@swd.co.th", name: "Pao1" },
      { email: "sountorn@swd.co.th", name: "Pao2" },
      { email: "pao@swd.co.th", name: "Pao3" },
      { email: "napat2@swd.co.th", name: "Pao4" },
    ],
    selected: [],
    emaillist: [],
    sensorlist: [],
    filtersensor: [[{ name: "Select Sensor Type First!" }]],
    conditionlist: [{ id: 1, type: "", sensid: "", con: "", value: "" }],
    tempsensorread: [],
    controlunit: [],
    mode: "",
    delayDelete: false,
    detail: "",
    lorakey: [["Select Sensor First!"]],
    TFlist: [
      { name: "True", value: true },
      { name: "False", value: false },
    ],
    Indoorlist: [
      { name: "True", value: 1 },
      { name: "False", value: 0 },
    ],
  }),
  methods: {
    pop() {
      this.filtersensor.pop();
      this.sencon.pop();
      this.lorakey.pop();
      this.conditionlist.pop();
    },
    actpop() {
      this.actionlist.pop();
    },
    addnewsens() {
      this.filtersensor.push([{ name: "Select Sensor Type First!" }]);
      this.sencon.push(["Greater Than", "Less Than"]);
      this.lorakey.push(["Select Sensor First!"]);
      this.conditionlist.push({
        id: this.conditionlist.length + 1,
        type: "",
        sensid: "",
        con: "",
        value: "",
      });
    },
    addnewact() {
      // this.filtersensor.push([{name:'Select Sensor Type First!'}])
      // this.sencon.push(["Greater Than","Less Than"])
      this.actionlist.push({
        id: this.actionlist.length + 1,
        name: "",
        detail: "",
      });
    },
    alertchange(type, index) {
      // console.log(type,index)
      // console.log(this.actionlist)
    },
    detailchange(detail, index) {
      // console.log(detail,index)
    },
    addnewcontrol() {},
    change() {
      // eslint-disable-next-line no-console
      // console.log(this.then)
    },
    sensorchange(item, i) {
      // console.log(this.filtersensor[i], this.lorakey[i])
      // // console.log(item,i)
      // this.lorakey[i] = []
      if (this.address[i]) {
        while (this.address[i].length > 0) {
          this.address[i].pop();
        }
      }
      if (this.lorakey[i] && this.delayDelete) {
        while (this.lorakey[i].length > 0) {
          this.lorakey[i].pop();
        }
      }
      var lastdata;
      this.filtersensor[i].forEach((element) => {
        if (item == element.id) {
          if (element.type != "Sensor") {
            console.log(element.lastdata);
            if (element.type == "monnit")
              lastdata = JSON.parse(element.lastdata);
            else lastdata = JSON.parse(element.lastdata[0]);
            // console.log(lastdata)
            Object.keys(lastdata).forEach((keys) => {
              switch (keys) {
                case "p1v00r0000x06":
                  this.address[i].push({ name: "Total Flow", value: keys });
                  break;
                case "p1v00r0000x09":
                  this.address[i].push({ name: "Total Flow", value: keys });
                  break;
                case "p1v00r0000x0a":
                  this.address[i].push({ name: "Total Flow", value: keys });
                  break;
                case "p1v00r0000x0b":
                  this.address[i].push({ name: "Total Flow", value: keys });
                  break;
                // case 'p1v00r0000x10':
                //   this.address[i].push({name:'Total Flow',value:keys})
                //   break;
                // case 'p1v00r0000x14':
                //   this.address[i].push({name:'Reverse Total Flow',value:keys})
                //   break;
                case "ai1":
                  this.address[i].push({ name: "PH", value: keys });
                  break;
                default:
                  this.address[i].push({ name: keys, value: keys });
                  break;
              }
            });
            if (
              element.type == "lora" ||
              element.type == "mqtt" ||
              element.type == "hino" ||
              element.type == "qcon" ||
              element.type == "lkb" ||
              element.type == "aqi" ||
              element.type == "cpf" ||
              element.type == "ajino" ||
              element.type == "frasers"
            ) {
              Object.keys(lastdata).forEach((keys) => {
                if (keys != "time") {
                  this.lorakey[i].push(keys);
                }
              });
            } else if (element.type == "monnit") {
              console.log(lastdata);
              try {
                lastdata.forEach((keys) => {
                  console.log(keys);
                  this.lorakey[i].push(keys.datatype);
                });
              } catch (err) {
                this.lorakey[i].push(lastdata.datatype);
              }
            }
          }
          if (element.type == "Sensor") {
            console.log("Object.keys(element.sensordata)", Object.keys(element.sensordata));
            // this.lorakey[i] = []
            Object.keys(element.sensordata).filter((key) => key != 'time' && key != 'triggered').forEach((key) => this.lorakey[i].push(key))
            // Object.keys(element.sensordata).forEach((keys) => {
            //   if (keys != "time" && keys != "triggered") {
            //     !this.lorakey[i].includes(key) && this.lorakey[i].push(keys);
            //   }
            // });
          }
        }
      });
    },
    actionchange(item, i) {
      while (this.filtersensor[i].length > 0) {
        this.filtersensor[i].pop();
      }
      this.sensorlist.forEach((element) => {
        if (element.type == "monnit") {
          if (element.type == item) {
            this.filtersensor[i].push(element);
          }
        } else if (element.type != null && element.type != "") {
          if (element.type == item) {
            this.filtersensor[i].push(element);
          }
        }
      });
      switch (item) {
        case "Humidity":
          this.sencon[i] = [
            "Humidity Greater Than (%)",
            "Humidity Less Than (%)",
            "Greater Than (°C)",
            "Less Than (°C)",
            "Greater Than (°F)",
            "Less Than (°F)",
          ];
          break;
        case "Temperature":
          this.sencon[i] = [
            "Greater Than (°C)",
            "Less Than (°C)",
            "Greater Than (°F)",
            "Less Than (°F)",
          ];
          break;
        case "Vibration":
          this.sencon[i] = ["Greater Than", "Less Than"];
          break;
        case "CT":
          this.sencon[i] = ["Amp Greater Than", "Amp Less Than"];
          break;
        case "control":
        case "O/C":
          this.sencon[i] = ["True", "False"];
          break;
        case "powermeter":
          this.sencon[i] = [
            "Amp Greater Than",
            "Amp Less Than",
            "Volt Greater Than",
            "Volt Less Than",
          ];
          break;
      }
    },
    clear() {
      this.actionselect = "Action Select";
      this.typeselect = "Type Select";
      this.con = "Greater Than";
      this.pt = "Type";
      this.value = "";
    },
    // send() {
    //   // console.log(this.conditionlist,this.actionlist)
    // }
    async getSensorDetail(id, type) {
      console.log(id, type);
      var sensorData;
      if (type == "S1" || type == "S4" || type == "Sensor") {
        sensorData = await this.$API.post("indoorsensor/alert/id", {
          id: id,
        });
      } else {
        sensorData = await this.$API.post("sensor/id", {
          id: id,
        });
      }
      console.log(sensorData.data);
      return sensorData.data[0];
    },
    async send() {
      for (let i = 0; i < this.conditionlist.length; i++) {
        if (this.conditionlist[i].loracon) {
          let str = this.conditionlist[i].loracon.toString();
          this.conditionlist[i]["param"] =
            str[0].toUpperCase() + str.slice(1, str.length);
        }
        if (
          this.conditionlist[i].type == "S1" ||
          this.conditionlist[i].type == "S4" ||
          this.conditionlist[i].type == "Sensor"
        )
          this.indoorCheck = true;
        this.conditionlist[i]["senname"] = await this.getSensorDetail(
          this.conditionlist[i].sensid,
          this.conditionlist[i].type
        );
      }
      for (let index = 0; index < this.actionlist.length; index++) {
        const element = this.actionlist[index];
        if (element.name == "LINE")
          switch (this.userAccount) {
            case "dhanarak-admin":
              this.actionlist[index].detail = "D-net";
              break;
            default:
              this.actionlist[index].detail = this.userAccount;
              break;
          }
      }
      console.log(this.actionlist);
      switch (this.mode) {
        case "edit":
          console.log({
            id: this.id,
            name: this.name,
            con: this.conditionlist,
            action: this.actionlist,
            active: true,
            singleSwitch: this.switchAlert,
          });
          this.$API.post("updateaction", {
            headers: {
              "Access-Control-Request-Method": "*",
              "Access-Control-Request-Headers": "*",
              Origin: "*",
            },
            id: this.id,
            name: this.name,
            con: this.conditionlist,
            action: this.actionlist,
            active: true,
            singleSwitch: this.switchAlert,
            indoor: this.indoorCheck,
            token: this.$session.get("token"),
          });
          this.$vs.notify({
            title: "Add Alert",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
          setTimeout(() => {
            if (this.userAccount == "betagrodemo")
              this.$router.push({ name: "IndoorAlertSetting" });
            else this.$router.push({ name: "Action" });
          }, 1000);
          break;
        case "create":
          console.log({
            id: this.id,
            name: this.name,
            con: this.conditionlist,
            action: this.actionlist,
            active: true,
            singleSwitch: this.switchAlert,
            indoor: this.indoorCheck,
          });
          this.$API.post("action", {
            headers: {
              "Access-Control-Request-Method": "*",
              "Access-Control-Request-Headers": "*",
              Origin: "*",
            },
            name: this.name,
            con: this.conditionlist,
            action: this.actionlist,
            singleSwitch: this.switchAlert,
            active: true,
            indoor: this.indoorCheck,
            token: this.$session.get("token"),
          });

          this.$vs.notify({
            title: "Add Alert",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
          setTimeout(() => {
            if (this.userAccount == "betagrodemo")
              this.$router.push({ name: "IndoorAlertSetting" });
            else this.$router.push({ name: "Action" });
          }, 1000);
          break;
      }
    },
  },
  beforeDestroy() {
    this.$session.remove("action");
    this.$session.remove("actiondetail");
  },
  async created() {
    
    // this.delayDelete = true;
  },
  async mounted() {
    this.mode = this.$session.get("action");
    this.detail = this.$session.get("actiondetail");
    console.log(this.detail);
    this.userAccount = this.$session.get("username");
    var sensor = "";
    await this.$API.get("account/user").then((result) => {
      this.emaillist = result.data;
      // console.log(this.emaillist)
    });
    var check = false;
    await this.$API.get("sensors/indoor/user").then((result) => {
      this.sensorlist = result.data;
      console.log(this.sensorlist);
      result.data.forEach((element) => {
        // console.log(element)
        if (element.type == "control" || element.type == "Control")
          this.controlunit.push(element);
        else if (element.type == "monnit") {
          check = false;
          this.sensorread.forEach((element2) => {
            if (element2 == element.type) check = true;
          });
          if (!check) {
            this.sensorread.push(element.type);
            check = false;
          }
        }
        else if (element.type != null && element.type != "") {
          check = false;
          this.sensorread.forEach((element2) => {
            console.log(element2, element.type)
            if (element2 == element.type) check = true;
          });
          if (!check) {
            this.sensorread.push(element.type);
            check = false;
          }
        }
      });
    });
    var check = false;
    if (this.detail) {
      this.$vs.loading();
      console.log(this.detail);
      this.detail.con.forEach((con, index) => {
        if (this.detail.indoor) {
          this.sensorlist.forEach((element) => {
            console.log(element.name, this.detail.con[index].senname.name);
            if (element.name == this.detail.con[index].senname.name) {
              sensor = element;
            }
          });
          var lastdata = sensor.sensordata;
          lastdata && Object.keys(lastdata).forEach((keys) => {
            console.log(keys);
            if (keys != "time" && keys != "triggered") {
              this.lorakey[index].push(keys);
            }
          });
          console.log(this.lorakey);
          // Object.keys(lastdata).forEach(keys => {
          //   if(keys != 'time') {
          //     this.lorakey[index].push(keys)
          //   }
          // });
          // if ("S1" === item) {
          //   this.sensorPM = ["Temperature", "Humidity"];
          //   this.sensorOP = ["Greater Than", "Less Than"];
          // } else {
          //   this.sensorPM = ["Door Status", "Install Status"];
          //   this.sensorOP = ["True", "False"];
          // }
        } else {
          this.sensorlist.forEach((element) => {
            // console.log(element.name, this.detail.con[index].sensid)
            if (element.name == this.detail.con[index].sensid) {
              sensor = element;
            }
          });
          if (sensor.lastdata) {
            var lastdata = JSON.parse(sensor.lastdata[index]);
            console.log(this.detail.con[index].type);
            if (this.detail.con[index].type == "monnit") {
              // lastdata = JSON.parse(element.lastdata);
              console.log(lastdata);
              try {
                lastdata.forEach((keys) => {
                  console.log(keys);
                  this.lorakey[index].push(keys.datatype);
                });
              } catch (err) {
                this.lorakey[index].push(lastdata.datatype);
              }
            } else {
              Object.keys(lastdata).forEach((keys) => {
                if (keys != "time" && keys != "triggered") {
                  this.lorakey[index].push(keys);
                }
              });
            }

          }
        }
      });
      setTimeout(() => {
        // console.log(this.detail.con[0].sensid)
        console.log(sensor);
        this.$vs.loading.close();
        this.id = this.detail.id;
        this.name = this.detail.name;
        this.switchAlert = this.detail.alertmode == "multiple" ? true : false;
        this.conditionlist = this.detail.con;
        // Object.keys(this.detail.con).forEach(element => {
        //   if(element == 'type')
        // });
        this.actionlist = this.detail.action;
        console.log(this.actionlist);
        this.conditionlist.forEach((element) => {
          if (element.type == "S1" || element.type == "S4")
            element.type = "Sensor";
          element.sensid = element.senname.name;
          if (element.type != "monnit")
            element["loracon"] = element.param.toLowerCase();
        });
        console.log(this.conditionlist);
        setTimeout(() => {
          this.delayDelete = true;
        }, 500);
      }, 1000);
    }
    else {
      setTimeout(() => {
          this.delayDelete = true;
        }, 1000);
    }
    // this.delayDelete = true;

    switch (this.userAccount) {
      case "betagrodemo":
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#212121";
          testElement.style.color = "#FFFFFF";
        });
        var elemtable = document.getElementsByClassName("vs-con-table");
        Array.prototype.filter.call(elemtable, function (testElementtable) {
          testElementtable.style.color = "#FFFFFF";
          testElementtable.style.background = "#212121";
        });

        document.getElementById("myDiv").style.paddingBottom = "500px";
        break;
      default:
        console.log("Try looking up for a hint.");
    }
  },
};
</script>
<style scoped>
.vs-button {
  border-radius: 20px;
}
.th {
  padding: 0%;
}
.border1 {
  padding: 0px;
  border-style: solid;
  border-width: 1px;
}
.border:hover {
  height: 0px;
  transition: 1000s;
}
span {
  text-transform: capitalize;
}
</style>
<style>
span {
  text-transform: capitalize;
}
.vs-select--input {
  text-transform: capitalize;
}
.vs-table--thead {
  z-index: 200;
  width: 100%;
  position: static;
}
</style>
